import { render, staticRenderFns } from "./SalTable.vue?vue&type=template&id=b688ccc0&scoped=true&"
import script from "./SalTable.vue?vue&type=script&lang=js&"
export * from "./SalTable.vue?vue&type=script&lang=js&"
import style0 from "./SalTable.vue?vue&type=style&index=0&id=b688ccc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b688ccc0",
  null
  
)

export default component.exports